import styles from './index.module.sass';

const CoinGround = () => {
  return <div className={styles['coin-ground']} />;
};

export default CoinGround;
